<template>
    <nav class="section">
      <div class="title">
        <span>Section</span>
        <span>{{ trimcount }} ({{ count }}) 글자</span>
        <Ubutton size="medium" icon="226" iconSize="xsmall" state="highlight" @click.native="reset"/>
      </div>
      <li class="sectionItem">
        <span>0</span>
        <div>
          <span>제목</span>
        </div>
      </li>
      <li class="sectionItem">
        <span>1</span>
        <div>
          <span>표지</span>
        </div>
      </li>
      <li class="sectionItem">
        <span>2</span>
        <div>
          <span>서지정보</span>
        </div>
      </li>
      <li class="sectionItem button" @click="createItem">
        <!-- <Ubutton size="medium" text="+ 추가하기 ctrl + shift + enter" state="deactive" @click.native="createItem"/> -->
        <span>+</span>
        <div>
          <span>추가하기 ctrl + shift + enter</span>
        </div>
      </li>
      <div class="scrollView">
        <li class="sectionItem" v-for="item in getData()" :key="item.index" :class="{'selected': item === selected}">
          <span @click="document.querySelector('#' + item.id).scrollIntoView()">{{ item.count }}</span>
          <div v-if="!item.isEdit">
            <span v-if="!item.isEdit" @click="document.querySelector('#' + item.id).scrollIntoView()">{{ item.name }}</span>
            <div>
              <span>{{ item.trimtextcount }} ({{ item.textcount }})</span>
              <Ubutton v-if="!item.notRemove" size="small" icon="217" iconSize="xsmall" state="deactive" @click.native="confirm(getRemoveParam(item), removeItem)"/>
              <Ubutton size="small" icon="222" iconSize="xsmall" state="deactive" @click.native="itemEdit(item)"/>
            </div>
          </div>
          <UInput v-else id="itemeditInput" type="text" @enter="itemSave(item)" @esc="item.isEdit = false" :value="item.name">
            <template #last>
              <Ubutton size="xxsmall" text="확인" state="active" @click.native="itemSave(item)"/>
            </template>
          </UInput>
        </li>
      </div>
    </nav>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import ES from '@/components/js/EditorSetting.js'
import {selection, resetRange, closest, getTime} from '@/components/js/Utils.js'

var filedName = 'section'
var idName = 'usv'

export default {
  props: {
    firstElement: {
      type: String
    },
    data: {
      type: Array,
      required: true
    },
    initBody: {
      type: String
    }
  },
  name: 'SectionEdit',
  created () {
    // console.log('section', this.initBody)
  },
  mounted () {
    this.$center.addStepEvent(ES.PASTE, 2, this.paste)
    this.$center.addStepEvent(ES.KEYDOWN, 2, this.keydown)
    this.$center.addStepEvent(ES.MOUSEDOWN, 2, this.mousedown)
    this.$center.addStepEvent(ES.COPY, 2, this.copy)
    this.$center.addStepEvent(ES.CUT, 2, this.cut)
    this.$center.addStepEvent(ES.SELECTION, 2, this.edit_selection)
    this.$center.addStepEvent(ES.REMOVE, 2, this.edit_remove)
    this.$center.addStepEvent(ES.DRAGSTART, 2, this.dragstart)
    if (!this.data.length) {
      var temp = [{
        id: this.firstElement,
        name: filedName + 1,
        count: 4,
        isEdit: false,
        notRemove: true
      }]
      this.$emit('update:data', temp)
    }
    setTimeout(() => {
      this.reset()
    })
  },
  beforeDestroy () {
    this.$center.removeStepEvent(ES.PASTE, this.paste)
    this.$center.removeStepEvent(ES.KEYDOWN, this.keydown)
    this.$center.removeStepEvent(ES.MOUSEDOWN, this.mousedown)
    this.$center.removeStepEvent(ES.COPY, this.copy)
    this.$center.removeStepEvent(ES.CUT, this.cut)
    this.$center.removeStepEvent(ES.SELECTION, this.edit_selection)
    this.$center.removeStepEvent(ES.REMOVE, this.edit_remove)
    this.$center.removeStepEvent(ES.DRAGSTART, this.dragstart)
  },
  data () {
    return {
      firstName: 'section1',
      count: 0,
      trimcount: 0,
      editfocus: null,
      selected: null,
      create: false
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    getData () {
      if (this.data.length === 0) {
        this.data.push({
          id: this.firstElement,
          name: filedName + 1,
          count: 4,
          isEdit: false,
          notRemove: true
        })
        this.$emit('update:data', this.data)
      }
      return this.data
    },
    mousedown (e) {
      setTimeout(() => {
        this.selectedItem()
      })
      if (closest(e.target, ES.SECTION)) {
        closest(e.target, ES.SECTION).classList.add(ES.toSELECT)
        setTimeout(() => {
          resetRange(closest(e.target, ES.SECTION).childNodes[0])
        })
        return ES.TYPE_SECTION
      }
    },
    paste (e) {
      var datalist = []
      e.pasteHTML.querySelectorAll(ES.SECTION).forEach((n) => {
        datalist.push(this.itemCreate(n))
      })
      setTimeout(() => {
        document.querySelectorAll(ES.SECTION).forEach((item, i) => {
          var d = datalist.find((n) => n.id === item.id)
          if (d) {
            this.data.splice(i + 1, 0, d)
          }
        })
        this.resetCount()
      })
    },
    edit_selection (e) {
      if (ES.hasSelection(this.selectionCheck, this.checkItem).length) {
        if (document.querySelector(ES.SELECT) === null) {
          return 'Section'
        }
      }
    },
    selectionCheck (s, t, ar) {
      if (t.classList.contains('sectionline')) {
        ar.push(t)
      }
    },
    checkItem (t) {
      t = closest(t, ES.SECTION)
      if (t) {
        return this.searchItem(t.id)
      }
      return null
    },
    createItem () {
      console.log('createItem')
      if (this.create === false) {
        this.create = true
        var d = this.itemCreate()
        this.$emit('action', 'create', d.element)
        setTimeout(() => {
          document.querySelectorAll(ES.SECTION).forEach((item, i) => {
            if (item.id === d.id) {
              this.data.splice(i + 1, 0, d)
            }
          })
          this.resetCount()
          this.create = false
        })
      }
    },
    itemCreate (el) {
      var t = getTime()
      var d = {
        id: idName + t,
        name: filedName + this.data.length,
        isEdit: false
      }
      if (el) {
        el.id = d.id
        d.element = el
      } else {
        var h = document.createElement('div')
        h.id = d.id
        h.className = 'u_tag ' + ES.toSECTION
        h.innerHTML = '<span class="section"/>'
        d.element = h
      }
      return d
    },
    reset () {
      this.count = 0
      var t = document.querySelector('#' + this.firstElement)
      var st = t.outerText
      this.count = st.length
      this.trimcount = st.replace(/\s/g, '').replace(/\r\n/g).length
      var f = t.firstChild
      var l = t.lastChild
      var re = []
      this.data.forEach((item, i) => {
        if (i === 0 || document.querySelector('#' + item.id)) {
          var r = document.createRange()
          switch (i) {
            case 0 :
              r.setStart(f, 0)
              if (this.data.length > 1) {
                r.setEnd(document.querySelector('#' + this.data[i + 1].id), 0)
              } else {
                console.log(l, l.lastChild, l.lastChild)
                r.setEnd(l.lastChild, l.lastChild.length - 1)
              }
              break
            default :
              r.setStart(document.querySelector('#' + item.id), 0)
              if (this.data.length - 1 === i || document.querySelector('#' + this.data[i + 1].id) === null) {
                r.setEnd(l.lastChild, l.lastChild.length)
              } else {
                r.setEnd(document.querySelector('#' + this.data[i + 1].id), 0)
              }
              break
          }
          item.textcount = r.toString().length
          item.trimtextcount = r.toString().replace(/\s/g, '').replace(/\r\n/g).length
        } else {
          item.textcount = 0
          item.trimtextcount = 0
          if (document.querySelector('#' + item.id) === null) {
            re.push(item)
          }
        }
      })
      for (var i = 0; i < re.length; i++) {
        this.data.splice(this.data.indexOf(re[i]), 1)
      }
    },
    bodyMove (item) {
      item.element.scrollIntoView()
    },
    getRemoveParam (item, action) {
      return {
        target: item.name,
        message: '섹션을 삭제 하시겠습니까?',
        icon: 'edit_delete',
        param: {item: item, action: action}
      }
    },
    itemEdit (item) {
      if (this.editfocus) {
        this.editfocus.isEdit = false
      }
      this.editfocus = item
      item.isEdit = true
      this.$nextTick(() => {
        document.querySelector('#itemeditInput input').focus()
      })
    },
    itemSave (item) {
      item.name = document.querySelector('#itemeditInput input').value
      item.isEdit = false
      this.editfocus = null
    },
    removeItem (e) {
      if (e.result) {
        console.log(e)
        this.$emit('action', 'remove', e.param.action)
        var t = this.getElement(e.param.item)
        console.log(t)
        if (t !== null) {
          t.parentNode.removeChild(t)
        }
        this.data.splice(this.data.indexOf(e.param.item), 1)
        this.resetCount()
      }
    },
    resetCount () {
      this.data.forEach((item, i) => { item.count = i + 4 })
      this.$emit('update:data', this.data)
      this.reset()
    },
    keydown (e) {
      var s = document.querySelector(ES.SELECT)
      switch (e.keyCode || e.which) {
        case 8 :
          if (s && closest(s, ES.SECTION)) {
            this.confirm(this.getRemoveParam(this.searchItem(s.id), 'prev'), this.removeItem)
            e.preventDefault()
          }
          break
        case 46 :
          if (s && closest(s, ES.SECTION)) {
            this.confirm(this.getRemoveParam(this.searchItem(s.id), 'next'), this.removeItem)
            e.preventDefault()
          }
          break
        case 32 :
          if (s && closest(s, ES.SECTION)) {
            e.preventDefault()
          }
          break
        case 13 :
        // enter
          if (s && closest(s, ES.SECTION)) {
            e.preventDefault()
          }
          if (e.ctrlKey && e.shiftKey) {
            console.log('key create')
            this.createItem()
            e.preventDefault()
          }
          break
        case 37 :
        case 38 :
        case 39 :
        case 40 :
          setTimeout(() => {
            this.selectedItem()
          })
          break
      }
    },
    selectedItem () {
      var s = selection()
      var t = closest(s.anchorNode, [ES.SECTION, ES.LINE, ES.IMG, ES.INDEX, ES.BLOCK, ES.ENTER])
      while (!t.classList.contains(ES.toSECTION) && t.previousSibling) {
        t = t.previousSibling
      }
      if (t.previousSibling) {
        t = this.searchItem(t.id)
      } else {
        t = this.data[0]
      }
      if (this.selected) {
        this.selected.selected = false
      }
      this.selected = t
      this.selected.selected = true
      this.$emit('update:data', this.data)
    },
    copy (e) {
      var s = document.querySelector(ES.SELECT)
      if (s && closest(s, ES.SECTION)) {
        var c = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData)
        c.setData('text/html', s.outerHTML)
        e.preventDefault()
      }
    },
    cut (e) {
      var s = document.querySelector(ES.SELECT)
      if (s && closest(s, ES.SECTION)) {
        var c = (e.clipboardData || window.clipboardData || e.originalEvent.clipboardData)
        c.setData('text/html', s.outerHTML)
        this.data.splice(this.data.indexOf(this.searchItem(s.id)), 1)
        s.parentNode.removeChild(s)
        e.preventDefault()
      }
    },
    searchItem (id) {
      return this.data.find((el) => el.id === id)
    },
    getElement (t) {
      if (!t.element || t.element !== document.querySelector('#' + t.id)) {
        t.element = document.querySelector('#' + t.id)
      }
      return t.element
    },
    edit_remove (e) {
      ES.hasSelection(this.selectionCheck, this.checkItem).forEach((n) => {
        console.log('remove', n)
        n.parentNode.removeChild(n)
        this.data.splice(this.data.indexOf(this.searchItem(n.id)), 1)
      })
      setTimeout(() => {
        this.resetCount()
      })
    },
    dragstart (e) {
    }
  },
  components: {
    'UInput': UInput
  }
}
</script>

<style>
.sectionline {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;
  width: 100%;
}
.sectionline .section {
  width: 100%;
  border-bottom: 1px dashed var(--require);
}
.sectionline .section::after {
  content: 'SECTION';
  position: absolute;
  left: 50%;
  color: var(--require);
  background-color: var(--bg-white);
  font-size: 10px;
  padding: 0px 5px;
  /* top: 50%; */
  transform: translateX(-50%) translateY(-50%);
}
.sectionline.selectTarget .section::after {
  background-color: #FAF4C0;
}
</style>

<style scope>
nav.section {
  z-index: 9;
  width: 290px;
  height: 100%;
  position: relative;
  background-color: var(--disable);
  flex-direction: column;
}
nav.section > div.title {
  background-color: var(--line-title);
  color: var(--bg-white);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 10px 0px 10px;
  height: 40px;
}
nav.section > div.title > span:first-child {
  margin-right: auto;
}
.sectionItem {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  min-height: 50px;
  align-items: center;
  padding: 0px 10px 0px 0px;
}
.sectionItem.button {
  border-top: 1px solid var(--line-base);
  border-bottom: 1px solid var(--line-base);
  cursor: pointer;
}
.sectionItem.button:hover {
  color: var(--bg-white);
  background-color: var(--deactive);
}
.sectionItem.selected {
  background-color: var(--bg-white);
}
.sectionItem > span:first-child {
  height: 100%;
  width: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
}
.sectionItem > div {
  width: 100%;
  /* margin-left: auto; */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sectionItem > div > div {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sectionItem .input {
  height: 100%;
  width: 100%;
  margin: 0;
}
.sectionItem .input button {
  margin-left: auto;
}
nav.section .scrollView {
  position: relative;
  height: calc(100vh - 55px - 40px - 200px);
  display: flex;
  flex-direction: column;
  /* line-height: 50px; */
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/SectionEdit.vue